var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_115_712)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#9BCD9B"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_115_712)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8894 22.5882V13.0631H8.66088V22.5882H11.8894ZM10.2756 11.7618C11.4014 11.7618 12.1022 11.0304 12.1022 10.1163C12.0812 9.1817 11.4014 8.47058 10.2969 8.47058C9.19257 8.47058 8.4704 9.18172 8.4704 10.1163C8.4704 11.0304 9.17101 11.7618 10.2545 11.7618H10.2755H10.2756ZM13.6764 22.5882H16.9049V17.2689C16.9049 16.9842 16.9259 16.6999 17.0111 16.4964C17.2445 15.9276 17.7757 15.3385 18.6676 15.3385C19.8359 15.3385 20.3032 16.212 20.3032 17.4924V22.5882H23.5316V17.1265C23.5316 14.2008 21.9388 12.8395 19.8146 12.8395C18.0729 12.8395 17.3082 13.7941 16.8834 14.4443H16.905V13.0629H13.6764C13.7188 13.9567 13.6764 22.588 13.6764 22.588L13.6764 22.5882Z",
    fill: "#F3F5FB"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_115_712"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_115_712"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.0588,
    height: 14.1176,
    fill: "white",
    transform: "translate(8.47058 8.47058)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinHover);
export default __webpack_public_path__ + "static/media/linkedinHover.a60bbf21478baf9aac7c8c85d4da0b03.svg";
export { ForwardRef as ReactComponent };